export const TIMEOUTS = {
    LOADING_FALLBACK: 10000,
    RESIZE_DEBOUNCE: 100
};

export const MESSAGES = {
    PEOPLE_DIRECTORY_READY: 'PEOPLE_DIRECTORY_READY',
    PEOPLE_PROFILE_READY: 'PEOPLE_PROFILE_READY',
};

export const SELECTORS = {
    HEADER: 'header',
    FOOTER: 'footer',
    NAVBAR_TOGGLE: '.navbar-toggle',
    NAVBAR_COLLAPSE_IN: '.navbar-collapse.in',
};
